import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime'
import { forwardRef } from 'react'
const SvgBrandIconPillBlister = (props, ref) =>
  _jsxs('svg', {
    viewBox: '0 0 48 48',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    ref: ref,
    ...props,
    children: [
      _jsx('circle', { cx: 24, cy: 24, r: 24, fill: '#fcf7f7' }),
      _jsx('path', {
        d: 'm28.668 24.535 6.081-6.08a.205.205 0 0 1 .309.02 4.52 4.52 0 0 1 .677 4.027 4.54 4.54 0 0 1-3.02 3.018 4.52 4.52 0 0 1-4.026-.677.205.205 0 0 1-.02-.308m-.707-.707 6.081-6.08a.205.205 0 0 0-.02-.31 4.52 4.52 0 0 0-4.028-.676 4.54 4.54 0 0 0-3.018 3.02 4.52 4.52 0 0 0 .677 4.025c.072.1.221.108.308.02m-6.74-2.687a4.582 4.582 0 1 1-9.164 0 4.582 4.582 0 0 1 9.165 0m-1 0c0-1.975-1.606-3.582-3.582-3.582s-3.582 1.607-3.582 3.582 1.607 3.583 3.582 3.583 3.583-1.607 3.583-3.583m-2.22 9.498a4.52 4.52 0 0 0-4.028.677.205.205 0 0 0-.02.308l6.08 6.08c.088.088.237.08.31-.02a4.52 4.52 0 0 0 .676-4.026A4.54 4.54 0 0 0 18 30.639m17.94 4.379a4.583 4.583 0 1 1-9.165 0 4.583 4.583 0 0 1 9.165 0m-1 0c0-1.975-1.607-3.582-3.582-3.582s-3.583 1.607-3.583 3.582 1.607 3.583 3.583 3.583 3.582-1.608 3.582-3.583M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24m-8.69-10.153a2 2 0 0 0-2-2H10.65a2 2 0 0 0-2 2V41.11A22.9 22.9 0 0 0 24 47c5.875 0 11.24-2.217 15.31-5.855zM13.244 32.33a.205.205 0 0 0-.308.02 4.52 4.52 0 0 0-.677 4.027 4.54 4.54 0 0 0 3.02 3.02 4.52 4.52 0 0 0 4.026-.678.205.205 0 0 0 .02-.308z',
      }),
    ],
  })
const ForwardRef = forwardRef(SvgBrandIconPillBlister)
export default ForwardRef
